import { useEffect } from "react";
import Typed from "typed.js";

export default function useTypedText() {
  useEffect(() => {
    const el = document.querySelector(".typed");
    if (!el) return;

    const strings = el.getAttribute("data-typed-items").split(",");

    const typed = new Typed(".typed", {
      strings,
      loop: true,
      typeSpeed: 100,
      backSpeed: 50,
      backDelay: 2000,
    });

    return () => typed.destroy();
  }, []);
}
